import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initTitles() {
  function moveLeftOnScroll(elements, triggerEnd) {
    elements.forEach((element) => {
      let distToScroll = -180;

      // let actualTriggerEnd = triggerEnd ? triggerEnd : "bottom top";

      let startX = 0;

      gsap.fromTo(
        element,
        {
          x: startX,
        },
        {
          x: distToScroll,
          duration: 1,
          scrollTrigger: {
            trigger: element,
            start: "top bottom",
            end: triggerEnd,
            scrub: 1,
            markers: false,
            onEnter: () => {
              /* ScrollTrigger.refresh(); */
            },
          },
        }
      );
    });
  }

  moveLeftOnScroll(document.body.querySelectorAll(".title-scroll"));
}
